import { Badge, Text, Tooltip } from '@radix-ui/themes';
import AddCollaboratorToJob from './AddCollaboratorToJob';

const colors = ['green', 'purple', 'grey', 'red', 'yellow', 'blue', 'orange', 'pink', 'teal'];
const Collaborators = ({
  users,
  add = false,
  refetching,
  groups,
}: {
  users: { user: { id: string; firstName: string; lastName: string; email: string; client: string; flag: string } }[];
  add?: boolean;
  refetching: () => void;
  groups: {
    accessGroup: {
      id: string;
      name: string;
      description: string;
      members: {
        id: string;
        firstName: string;
        lastName: string;
      }[];
      jobs: unknown[];
    };
  }[];
}) => {
  const seen = new Set();
  return (
    <span className="">
      {groups &&
        groups.map((ag, index) => {
          const group = ag.accessGroup;
          if (!group.id) return null;
          else {
            const color = parseInt(group.id.substring(0, 8), 16) % colors.length;
            return <GroupPill key={`group-key-${index}`} group={group} color={colors[color]} />;
          }
        })}
      {users &&
        users
          .filter((x) => {
            const n = seen.size;
            return x.user !== null && n !== seen.add(x.user.id).size;
          })
          .map((x, index) => {
            const user = x.user;
            if (user && index > 2 && index < 4) {
              return (
                <span key={index} className={'name-pill dark-grey border'}>
                  +{users.length - index}
                </span>
              );
            } else if (user && index <= 2) {
              const color = parseInt(user.id.substring(0, 8), 16) % colors.length;
              return <NamePill key={`collaborator-${user.id}`} user={user} color={colors[color]} />;
            } else return null;
          })}
      {add && <AddCollaboratorToJob users={users} refetching={refetching} groups={groups} />}
    </span>
  );
};

export default Collaborators;

const NamePill = ({ user, color }: { user: { id: string; firstName: string; lastName: string }; color: string }) => {
  return (
    <Tooltip
      content={
        <Text size="3">{`${user.firstName ? user.firstName : null} ${user.lastName ? user.lastName : null}`}</Text>
      }
    >
      <span className={'name-pill ' + color} style={{ marginRight: '-0.5rem', border: '1px var(--white) solid' }}>
        {user.firstName ? user.firstName.slice(0, 1) + user.lastName.slice(0, 1) : 'HU'}
      </span>
    </Tooltip>
  );
};
const GroupPill = ({
  group,
  color,
}: {
  group: { id: string; name: string; members: { id: string; firstName: string; lastName: string }[] };
  color: string;
}) => {
  return (
    <Tooltip
      content={
        <Text size="3">
          <strong>{group.name}</strong>
          {group.members &&
            group.members.map((members) => {
              return <li key={`grouplist-${members.id}`}>{`${members.firstName} ${members.lastName}`} </li>;
            })}
        </Text>
      }
    >
      <Badge className={'group-pill ' + color} radius="large">
        {group.name}
      </Badge>
    </Tooltip>
  );
};
